import React from "react";
import I18n from "i18n-js";

import { getCellColor } from "../services/flag";

const FlagsTable = ({ data, onFlagClick }) => {

  if (!data?.length) {
    return (
      <div className="flags">
        <span className="no-items">
          {I18n.t("insights.stats.flags.no_items")}
        </span>
      </div>
    );
  }
  
  return (
    <div className="flags">
      <table className="flags-table">
        <thead>
          <tr>
            <th>{I18n.t("insights.stats.flags.entity")}</th>
            <th>{I18n.t("insights.stats.flags.flagm")}</th>
            <th>{I18n.t("insights.stats.flags.flagt")}</th>
            <th>{I18n.t("insights.stats.flags.flag")}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} onClick={() => onFlagClick && onFlagClick(row)}>
              <td><span title={row.entity}>{row.entity}</span></td>
              <td style={{ backgroundColor: getCellColor(row.flagm) }}></td>
              <td style={{ backgroundColor: getCellColor(row.flagt) }}></td>
              <td style={{ backgroundColor: getCellColor(row.flag)  }}></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FlagsTable;
